export const ADD_PRACTICE_TYPES = {
  MY_TIMERS: 'myTimers',
  CREATE_NEW: 'createNew',
}
